import styled from "@emotion/styled"
import {
    CleaningNewStatus,
    colorCleaningNewStatus,
    displayCleaningNewStatus
} from "@/domain/cleaningNewStatus"
import { useAccountInfoCtx } from "@/hooks/useAccountInfo"

const getLabelAndColor = (
    status: CleaningNewStatus | undefined,
    isMatsuri: boolean,
    hasAssignedCompany = false
): { label?: string; color?: string } => {
    const label = displayCleaningNewStatus(
        status,
        isMatsuri,
        hasAssignedCompany
    )
    const color = colorCleaningNewStatus(status, isMatsuri, hasAssignedCompany)

    return { label, color }
}

const ChipElement = styled.div<{ backgroundColor: string }>`
    background-color: ${props => props.backgroundColor};
    border-radius: 14px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    width: 122px;
    height: 30px;
    line-height: 30px;
`

export const CleaningNewStatusChip = (props: {
    status: CleaningNewStatus | undefined
    hasAssignedCompany?: boolean
}) => {
    const { isMatsuri } = useAccountInfoCtx()
    const { label, color } = getLabelAndColor(
        props.status,
        isMatsuri,
        props.hasAssignedCompany ?? false
    )

    // 高さを揃えるために空のChipElementを返す
    if (!label || !color) return <ChipElement backgroundColor="inherit" />

    return <ChipElement backgroundColor={color}>{label}</ChipElement>
}
